import qs from 'query-string';
import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { JiraPlanDataRestResponse } from '@atlassian/jira-software-backlog-uif-types/src/index.tsx';
import type { FetchPlanOptions } from './types.tsx';

export function fetchPlanData(
	fetchPlanOptions: FetchPlanOptions,
): ObservableType<JiraPlanDataRestResponse> {
	return fetchJson$(
		`/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${qs.stringify(fetchPlanOptions)}`,
	);
}
